import { createContext } from "react";

const ModalsContext = createContext(undefined as any);

export default ModalsContext;
